import { usePlayerColor } from "~/jsx/hook/usePlayerColor";
import { XTroop } from "./XTroop";
import { CSSProperties } from "react";

export const XPlayerTroop = ({
  width,
  playerId,
  style,
}: {
  width: number;
  playerId: string;
  style?: CSSProperties;
}) => {
  const color = usePlayerColor(playerId);
  return <XTroop width={width} color={color ?? undefined} style={style} />;
};
